const styles = () => ({
  width: '100%',
});

export default styles;
